export const SECTIONS = [
    {
        id: 'strategy',
        name: 'Strategy & Approach',
        description: 'Define your core marketing philosophy',
        icon: 'target',
        questions: [
            {
                id: 'optimization_approach',
                title: 'Optimization Approach',
                description: 'Describe your approach to optimization',
                placeholder: 'How do you determine if a campaign/adset is effective? What signals do you look for?',
            },
            {
                id: 'budget_allocation',
                title: 'Budget Allocation',
                description: 'Describe your general approach to budget allocation across channels',
                placeholder:
                    'How do you distribute budget across different marketing channels? What factors influence your decisions?',
            },
        ],
    },
    {
        id: 'metrics',
        name: 'Metrics & Analysis',
        description: 'How you measure and analyze performance',
        icon: 'chart-bar',
        questions: [
            {
                id: 'key_metrics',
                title: 'Key Metrics',
                description: 'What are the metrics that you care about?',
                placeholder: 'List the KPIs and metrics you track (e.g., ROAS, CPA, LTV, retention rates...)',
            },
            {
                id: 'monetization_model',
                title: 'Monetization Model',
                description: 'Do you monetize based on AdMon / IAP / Subscription?',
                placeholder: 'Describe your monetization strategy and how it affects your marketing decisions...',
            },
            {
                id: 'attention_triggers',
                title: 'Attention Triggers',
                description: 'How do you determine the datapoints that require attention?',
                placeholder: 'What thresholds or anomalies trigger you to investigate specific metrics?',
            },
        ],
    },
    {
        id: 'operations',
        name: 'Operations & Decisions',
        description: 'Your decision-making process and constraints',
        icon: 'adjustments',
        questions: [
            {
                id: 'root_cause_analysis',
                title: 'Root Cause Analysis',
                description: 'How do you do a root cause analysis?',
                placeholder: 'Describe the steps you follow when investigating unexpected performance changes...',
            },
            {
                id: 'constraints',
                title: 'Constraints',
                description: 'Are you Budget constrained or ROAS constrained?',
                placeholder: 'Describe your primary constraints and how they affect your decisions...',
            },
            {
                id: 'creative_optimization',
                title: 'Creative Optimization',
                description: 'Describe your approach to creative optimization',
                placeholder: 'When do you iterate, switch out, or double down on specific creatives?',
            },
            {
                id: 'weekly_summary',
                title: 'Weekly Summary',
                description: 'What would you like to see in a weekly summary of your marketing data?',
                placeholder: "List the reports, insights, and visualizations you'd find most valuable...",
            },
        ],
    },
    {
        id: 'additional_context',
        name: 'Additional Context',
        description: 'Anything else you want the AI to know',
        icon: 'bulb',
        questions: [
            {
                id: 'other',
                title: 'Other',
                description:
                    "Share any additional context, preferences, or nuances about your business that don't fit into the categories above",
                placeholder:
                    'Feel free to add anything else the AI should know - team structure, seasonality,' +
                    ' unique business context, preferred tone, terminology you use internally,' +
                    ' or anything else that would help generate better insights...',
            },
        ],
    },
];

export const ALL_QUESTIONS_COUNT = SECTIONS.reduce((total, section) => total + section.questions.length, 0);

export const TOAST_CONFIG = { autoClose: 5000 };
